import React, { useState, useEffect } from 'react'
import { v4 } from 'uuid'
import { useDispatch } from 'react-redux'
import WebSocketProvider from 'src/WebSocket'
import SplashScreenWeb from 'src/components/SplashScreen'
// import { getChannelWebMessages } from 'src/actions/channelWeb'

import { useHistory, useParams } from 'react-router'
const defaultKey = 'smartbotsWebChatUserId'

function ChannelWebGuard({ children }) {
  const dispatch = useDispatch()
  const { botId, userId } = useParams()
  const history = useHistory()
  let uId = localStorage.getItem(defaultKey)
  const [isLoading, setLoading] = useState(true)

  if (!uId) {
    uId = v4()
    localStorage.setItem(defaultKey, uId)
  }

  useEffect(() => {
    const initWebChat = async () => {
    // dispatch(getChannelWebMessages(uId, botId))
      setLoading(false)
      if (!userId) {
        history.push(`/channelWeb/${botId}/${uId}/${document.location.search}`)
      }
    }
    initWebChat()
  }, [dispatch, botId, history])

  if (isLoading) {
    return <SplashScreenWeb />
  }

  return <WebSocketProvider room={userId}>{children}</WebSocketProvider>
}

export default ChannelWebGuard
